<template>
  <v-container fluid>
      <v-layout justify-center>
          <v-flex md10>
            <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
          </v-flex>
      </v-layout>
      <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="object" :urls="url" :message="message" />
      <!--
      <RolesDialog :model="user" v-if="get_dialogMain.dialog && (get_dialogMain.type == 'create' || get_dialogMain.type == 'update')" />
      -->
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import router from '@/router'

export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Clave', value: 'slug', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Acceso Especial', value: 'AccessAll', class: 'black--text' },
          // { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          // { text: 'Fecha Actualizada', value: 'Updated', class: 'black--text' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'asignar Permisos', icon: 'mdi-border-color', color: 'lime lighten-1', action: 'permissionsAssign', code: 'libre', hidden: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    user: {},
    form: [],
    object: {},
    url: {},
    message: ''
  }),
  components: {
    DataTableMain,
    MainFormDialog
  },
  mounted () {
    this.getUrl('POST/config/auth/roles/show')
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/config/auth/roles/show')
    },
    newData (item) {
      this.form = this.get_roleForm
      this.object = {}
      this.url = this.get_urls['POST/config/auth/roles/store']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 500, title: 'Nuevo Rol' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    permissionsAssign (item) {
      router.push({ name: 'ViewPermissionsRoleAssign', params: { id: item.item.id } })
    },
    ...mapActions(['getUrlServices', 'postServiceListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects', 'get_roleForm'])
  },
  watch: {
    get_urls () {
      this.getUrl('POST/config/auth/roles/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }

}
</script>

<style>

</style>
